<template>
  <div class="life_costs-pages-nopermissions" id="life_costs-pages-nopermissions">
    <div class="clearfix nopermissions-cont">
      <div class="pull-left" style="width:320px;">
        <span class="nopermissions-img"></span>
      </div>
      <div class="pull-left" style="width:340px;margin-left:80px;">
        <p class="nopermissions-tips">您没有足够的权限，无法访问请求页面</p>
        <p class="nopermissions-tips1">请尝试以下操作</p>
        <p class="nopermissions-tips2">
          <span style="display:block;"><span style="font-size: 20px;">.</span>检查登录账号是否正确</span>
          <span style="display:block;"><span style="font-size: 20px;">.</span>联系管理员进行授权</span>
        </p>
        <div class="btnsbox">
          <button class="backhome J_backhome" @click.stop="backhomeEvt">返回系统首页</button>
          <button class="backhome J_backlogin" @click.stop="backloginEvt">重新登录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ajax from '../lib/axios/ajax'
import { loginLogout } from '../lib/axios/apilist'

export default {
  //这里必须 使用一个方法返回给data
  data: function () {
    // 请求地址
    let ajaxParam = {
      loginLogout: loginLogout,
    };
    return {
      ajaxParam,
    }
  },
  mounted() {
  //进入页面
  //cabinVue 里面所有的this 都指向当前这个vue 实例
  //vue 更多使用方法请查看vue官方文档
    this.$nextTick(function(){
      // nextTick 用于当data数据改变,触发vue 渲染,且渲染完毕使用
    });
  },
  beforeCreate () {
  },
  //如果 不需要保存页面状态必须添加下面这个方法
  beforeDestroy:function () {
    
  },
  destroyed: function () {
    //离开页面方法
  },
  //监听属性变化，，变量必须是data里声明的
  watch:{},
  //监听属性变化，配置变量的同时也起到data声明的作用
  computed: {
  },
  methods: {
    backPrevPageEvt() { //返回上一页
      this.$router.go(-1)
    },
    backhomeEvt() { //返回首页
      this.$router.push({
        path: '/index'
      })
    },
    backloginEvt() { //返回登录页
      let userName = this.$refs('userName').data('userName')
      let param = {
        'userId': userName
      }
      let url = this.ajaxParam.loginLogout
      
      let successFunc = (res) => {
        // 关闭加载效果
        if (res.code === "0000") {
          this.$router.push({
            path: '/login'
          })
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) =>{
        // 关闭加载效果
        this.$error({
          title: '提示',
          content: res.result,
        });
      };

      ajax.fetch(url, param, successFunc, errorFunc)
      
    }
  }
}
</script>

<style scoped>

</style>